<template>
  <div class="pt-10">
    <div class="row align-items-center">
      <div class="col-6 col-md-6 mt-5 pt-5">
        <h5 class="text-danger">
          <strong>PROMOCIONES</strong>
        </h5>
      </div>
      <div class="col-6 col-md-3 mt-5 pt-5 align-self-center">
        <button
          @click="openModal()"
          data-bs-toggle="modal"
          data-bs-target="#modalPromo"
          class="btn btn-danger btn-block"
        >
          NUEVA PROMOCIÓN
        </button>
      </div>
    </div>
  
    <!-- Lista de promociones -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <caption class="visually-hidden">Listado de Promociones</caption>
            <thead>
              <tr>
                <th scope="col" style="text-align: left">Nombre de la promoción</th>
                <th scope="col" style="text-align: left">Fecha inicial</th>
                <th scope="col" style="text-align: left">Fecha final</th>
                <th scope="col" style="text-align: left">Distribuidor</th>
                <th scope="col" style="text-align: left">Tipo de usuario</th>
                <th scope="col" style="text-align: left">Puntos</th>
                <th scope="col" style="text-align: left">Estado</th>
                <th scope="col" style="text-align: center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :key="item.id">
                <td style="text-align: left">
                  {{ item.name_promotion }}
                </td>
                <td style="text-align: left">
                  {{ item.initial_date }}
                </td>
                <td style="text-align: left">
                  {{ item.final_date }}
                </td>
                <td style="text-align: left">
                  <h5 v-if="item.distributor_id == null">
                    <span class="badge badge-pill badge-danger">
                      {{ 'No aplica' }}
                    </span>
                  </h5>
                  <span v-else>
                    {{ item.users.name }}
                  </span>
                </td>
                <td style="text-align: left">
                  <h5 v-if="item.type_user == null">
                    <span class="badge badge-pill badge-danger">
                      {{ 'No aplica' }}
                    </span>
                  </h5>
                  <span v-else>
                    {{ 
                      item.type_user == 1 ? 'Motero' : 
                      item.type_user == 2 ? 'Lubricador' : 
                      'Motero y Lubricador' 
                    }}
                  </span>
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-danger">
                      {{ item.points }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  {{ item.status.name }}
                </td>

                <td style="text-align: center">
                  <div class="btn-group" role="group">
                    <button
                      data-toggle="tooltip"
                      data-placement="bottom"
                      class="btn btn-info mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                      title="Editar promoción"
                      @click="openModalEdit(item)"
                    >
                    <i class="fa fa-pencil m-0 p-0" aria-hidden="true"></i>
                    </button>
                  </div>
                  <template>
                    <div class="btn-group" role="group">
                      <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="btn btn-success mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                        title="Usuarios beneficiados"
                        @click="viewInscription(item)"
                      >
                        <i class="fa fa-users m-0 p-0" aria-hidden="true"></i>
                      </button>
                    </div>
                  </template>
                  <template>
                    <div class="btn-group" role="group">
                      <button
                        data-toggle="tooltip"
                        data-placement="bottom"
                        class="btn btn-danger mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                        title="Eliminar promoción"
                        @click="deletePromotion(item)"
                      >
                        <i class="fa fa-trash m-0 p-0" aria-hidden="true"></i>
                      </button>
                    </div>
                  </template>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  
    <!-- Paginación -->
    <div style="margin:25px 5px 5px 5px;" class="d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" :class="{disabled: currentPage === 1}">
            <a class="previous page-link" href="#" @click.prevent="prevPage()">
              <
            </a>
          </li>
          <li class="page-item" v-for="page in pages" :key="page" :class="{active: currentPage === page}">
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>
          <li class="page-item" :class="{disabled: currentPage === totalPages}">
            <a class="next page-link" href="#" @click.prevent="nextPage()">
              >
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- Fin lista de promociones -->

    <!-- Modal creación de promoción -->
    <div
      class="modal fade"
      id="modalPromo"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-xl">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>CREAR PROMOCIÓN</strong>
                </label><br>
              </div>
  
              <!-- Estructura del formulario -->
              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-12 col-md-12 m-0 p-0">
                      <div class="row">

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Nombre de la promoción *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.namePromotion }"
                              type="text"
                              v-model="form.namePromotion"
                              class="form-control"
                              placeholder="Escribe aquí el nombre"
                            />
                          </div>
                          <span
                            v-if="errors.namePromotion"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.namePromotion }}</span
                          >
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha inicial *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.initialDate }"
                              type="date"
                              v-model="form.initialDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha inicial"
                            />
                          </div>
                          <span v-if="errors.initialDate" class="text-danger float-left small error-danger mb-2">
                            {{ errors.initialDate }}
                          </span>
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha final *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.finalDate }"
                              type="date"
                              v-model="form.finalDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha final"
                            />
                          </div>
                          <span v-if="errors.finalDate" class="text-danger float-left small error-danger mb-2">
                            {{ errors.finalDate }}
                          </span>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>¿Cómo desea segmentar la promoción? *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.segment }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.segment"
                            >
                              <option value="null" disabled selected>Elegir segmento</option>
                              <option value="1">Por distribuidor</option>
                              <option value="2">Por tipo de usuario</option>
                            </select>
                          </div>
                          <span v-if="errors.segment" class="text-danger float-left small error-danger mb-2">
                            {{ errors.segment }}
                          </span>
                        </div>
  
                        <div v-if="form.segment == 1" class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>Distribuidor *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.distributor }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.distributor"
                            >
                              <option value="null" disabled selected>Seleccione el Distribuidor</option>
                              <option 
                                v-for="item in allDistributors" 
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span v-if="errors.distributor" class="text-danger float-left small error-danger mb-2">
                            {{ errors.distributor }}
                          </span>
                        </div>
  
                        <div v-if="form.segment == 2" class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>Tipo de usuario *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.typeUser }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="form.typeUser"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                              <option value="1">Motero</option>
                              <option value="2">Lubricador</option>
                              <option value="3">Motero y Lubricador</option>
                            </select>
                          </div>
                          <span v-if="errors.typeUser" class="text-danger float-left small error-danger mb-2">
                            {{ errors.typeUser }}
                          </span>
                        </div>
                          
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Puntos *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="form.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos"
                            />
                          </div>
                          <span v-if="errors.points" class="text-danger float-left small error-danger mb-2">
                            {{ errors.points }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="createPromotion()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    >
                    </span>
                    Creando...
                  </template>
                  <template v-else>Crear</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin modal creación de promoción -->
  
    <!-- Modal edición de promoción -->
    <div
      class="modal fade"
      id="modalPromoEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered border-danger modal-xl">
        <div class="modal-content modal-promotional">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161;">
                  <strong>EDITAR PROMOCIÓN</strong>
                </label><br>
              </div>
  
              <!-- Estructura del formulario -->
              <div class="col-12 m-0 p-0">
                <div class="form-group">
                  <div class="row" style="text-align: left">
                    <div class="col-12 m-0 p-0">
                      <div class="row">

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Nombre de la promoción *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.namePromotion }"
                              type="text"
                              v-model="formEdit.namePromotion"
                              class="form-control"
                              placeholder="Escribe aquí el nombre"
                            />
                          </div>
                          <span
                            v-if="errors.namePromotion"
                            class="text-danger float-left small error-danger mb-2"
                            >{{ errors.namePromotion }}</span
                          >
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha inicial *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.initialDate }"
                              type="date"
                              v-model="formEdit.initialDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha inicial"
                            />
                          </div>
                          <span
                              v-if="errors.initialDate"
                              class="text-danger float-left small error-danger mb-2"
                              >{{ errors.initialDate }}</span
                          >
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Fecha final *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.finalDate }"
                              type="date"
                              v-model="formEdit.finalDate"
                              class="form-control"
                              placeholder="Escribe aquí la fecha final"
                            />
                          </div>
                          <span
                              v-if="errors.finalDate"
                              class="text-danger float-left small error-danger mb-2"
                              >{{ errors.finalDate }}</span
                          >
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>¿Cómo desea segmentar la promoción? *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.segment }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.segment"
                            >
                              <option value="null" disabled selected>Elegir segmento</option>
                              <option value="1">Por distribuidor</option>
                              <option value="2">Por tipo de usuario</option>
                            </select>
                          </div>
                          <span v-if="errors.segment" class="text-danger float-left small error-danger mb-2">
                            {{ errors.segment }}
                          </span>
                        </div>

                        <div v-if="formEdit.segment == 1" class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>Distribuidor *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.distributor }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.distributor"
                            >
                              <option value="null" disabled selected>Seleccione el Distribuidor</option>
                              <option
                                v-for="item in allDistributors"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span
                              v-if="errors.distributor"
                              class="text-danger float-left small error-danger mb-2"
                          >{{ errors.distributor }}</span
                          >
                        </div>
  
                        <div v-if="formEdit.segment == 2" class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>Tipo de usuario *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.typeUser }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.typeUser"
                            >
                              <option value="null" disabled selected>Seleccione el tipo de usuario</option>
                              <option value="1">Motero</option>
                              <option value="2">Lubricador</option>
                              <option value="3">Motero y Lubricador</option>
                            </select>
                          </div>
                          <span
                              v-if="errors.typeUser"
                              class="text-danger float-left small error-danger mb-2"
                          >{{ errors.typeUser }}</span
                          >
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color: #616161; font-size: 14px"
                              ><strong>Puntos *</strong>
                            </label>
                            <input
                              :class="{ 'is-danger': errors.points }"
                              type="number"
                              v-model="formEdit.points"
                              class="form-control"
                              placeholder="Escribe aquí los puntos"
                            />
                          </div>
                          <span
                              v-if="errors.points"
                              class="text-danger float-left small error-danger mb-2"
                              >{{ errors.points }}</span
                          >
                        </div>
  
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label
                              class="ml-1"
                              for="state"
                              style="color:#616161; font-size:14px"
                              ><strong>Activar e inactivar promoción *</strong>
                            </label>
                            <select
                              :class="{ 'is-danger': errors.status_id }"
                              class="form-control"
                              name="state"
                              id="state"
                              v-model="formEdit.status_id"
                            >
                              <option value="null" disabled selected>Activar e inactivar promoción</option>
                              <option value="1">Activa</option>
                              <option value="2">Inactiva</option>
                            </select>
                          </div>
                          <span
                              v-if="errors.status_id"
                              class="text-danger float-left small error-danger mb-2"
                          >{{ errors.status_id }}</span
                          >
                        </div>
  
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3">
                <button
                  @click="updatePromotion()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.history">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                      Actualizando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fin modal edición de promoción -->
  </div>
</template>

<script>
  import $ from "jquery";
  import vPagination from "vue-plain-pagination"
  import axios from "axios";
  
  export default {
    components: { vPagination },

    data() {
      return {
        items: [],
        allDistributors: [],
        // Paginación
        currentPage: 1,
        pageSize: 10,
        totalDatos: 0,
        totalPages: 0,
        paginatedData: [],
        paginationVisible: true,
        form: {
          namePromotion: null,
          initialDate: null,
          finalDate: null,
          segment: null,
          distributor: null,
          typeUser: null,
          points: null
        },
        errors: {
          namePromotion: false,
          initialDate: false,
          finalDate: false,
          segment: false,
          distributor: false,
          typeUser: false,
          points: false
        },
        loading: {
          history: false,
        },
        formEdit: {
          namePromotion: null,
          initialDate: null,
          finalDate: null,
          segment: null,
          distributor: null,
          typeUser: null,
          points: null,
          status_id: 1
        },
      };
    },
    computed: {
      pages() {
        const pages = [];
        const limit = this.totalPages > 5 ? 5 : this.totalPages;
        let start = this.currentPage - 2;
        if (start <= 0) start = 1;
        let end = start + limit - 1;
        if (end > this.totalPages) {
          end = this.totalPages;
          start = end - limit + 1;
          if (start <= 0) start = 1;
        }
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        return pages;
      },
    },
    methods: {
      getDistributors(){
        var app = this;
        axios
        .get('superAdmin/get/distributors')
        .then((response) => {
          if(response.data.cod == 0){
            app.allDistributors = response.data.data;
          } else {
            app.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: response.data.message,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      },
      getPromotions() {
        this.loading.history = true;
        this.items = [];
        axios
          .get("admin/list-promotion")
          .then((res) => {
            this.loading.history = false;
            if (res.data.cod == 0) {
              if(res.data.data.length > 0){
                this.items = res.data.data;
                this.totalDatos = this.items.length;
                this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
                this.paginated();
                // console.log(JSON.stringify(this.items));
              } else {
                this.$swal({
                  icon: "info",
                  title: "Oops...",
                  text: res.data.message,
                  confirmButtonColor: "#dc3545"
                });
              }
            }
          })
          .catch((error) => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
      },
      openModal() {
        $("#modalPromo").modal("show");
      },
      validateForm(){
        if(this.form.namePromotion == null){
          this.errors.namePromotion = "Este campo es requerido.";
          return false;
        } else {
          this.errors.namePromotion = false;
        }
        if(this.form.initialDate == null){
          this.errors.initialDate = "Este campo es requerido.";
          return false;
        } else {
          this.errors.initialDate = false;
        }
        if(this.form.finalDate == null){
          this.errors.finalDate = "Este campo es requerido.";
          return false;
        } else {
          this.errors.finalDate = false;
        }
        if(this.form.segment == null){
          this.errors.segment = "Este campo es requerido.";
          return false;
        } else {
          this.errors.segment = false;
        }
        if(this.form.segment == 1){
          if(this.form.distributor == null){
            this.errors.distributor = "Este campo es requerido.";
            return false;
          }
        } 
        else if(this.form.segment == 2) {
          if(this.form.typeUser == null){
            this.errors.typeUser = "Este campo es requerido.";
            return false;
          }
        }
        if(this.form.points == null){
          this.errors.points = "Este campo es requerido.";
          return false;
        } else {
          this.errors.points = false;
        }

        return true;
      },
      createPromotion(){
        // console.log(JSON.stringify(this.form));
        if(this.validateForm()){
          this.loading.history = true;
          axios
          .post("admin/create-promotion/", this.form)
          .then((res) => {
            this.loading.history = false;
            if (res.data.cod == 0) {
              $("#modalPromo").modal("hide");
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              this.clearForm();
              this.getPromotions();
            }
          })
          .catch((error) => {
            this.loading.history = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          });
        }
      },
      clearForm() {
        this.form = {
          namePromotion: null,
          initialDate: null,
          finalDate: null,
          distributor: null,
          typeUser: null,
          points: null
        };
        setTimeout(() => {
          this.errors = {
            namePromotion: false,
            initialDate: false,
            finalDate: false,
            distributor: false,
            typeUser: false,
            points: false
          }
        }, 500);
      },
      openModalEdit(data){
        // console.log('data ', JSON.stringify(data));
        this.formEdit.id = data.id;
        this.formEdit.namePromotion = data.name_promotion;
        this.formEdit.initialDate = data.initial_date;
        this.formEdit.finalDate = data.final_date;
        this.formEdit.segment = data.segment;
        this.formEdit.distributor = data.distributor_id;
        this.formEdit.typeUser = data.type_user;
        this.formEdit.points = data.points;
        this.formEdit.status_id = data.status_id;
        $("#modalPromoEdit").modal("show");
      },
      viewInscription(data) {
        this.$router.push({ name: "listPromoUsers", params: { id: data.id } });
      },
      deletePromotion(item){
        this.$swal({
          icon: "question",
          title: "¿Estás seguro que deseas eliminar la promoción?",
          text: "Esta acción es irreversible",
          confirmButtonText: "Sí",
          confirmButtonColor: "#dc3545",
          showCancelButton: true,
          cancelButtonText: "No"
        }).then((result) => {
          if(result.isConfirmed){
            axios
            .post('admin/delete-promotion/' + item.id)
            .then((res) => {
              if (res.data.cod == 0) {
                this.$swal({
                  confirmButtonColor: "#dc3545",
                  icon: "success",
                  title: "Muy bien",
                  text: res.data.message,
                });
                this.getPromotions();
              }
            })
            .catch((error) => {
              this.loading.history = false;
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: error.response.data.message,
              });
            });
          }
        });        
      },
      updatePromotion(){
        this.loading.history = true;
        // console.log('this.formEdit: ', JSON.stringify(this.formEdit));
        axios
        .post("admin/update-promotion/", this.formEdit)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            $("#modalPromoEdit").modal("hide");
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.getPromotions();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          }).then(() => {
            $("#modalPromoEdit").modal("hide");
          });
        });
      },

      // Paginación
      paginated() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.paginatedData = this.items.slice(start, end);
      },
      changePage(page) {
        this.currentPage = page;
        this.paginated();
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.paginated();
        }
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.paginated();
        }
      },
      changeSize(size) {
        this.pageSize = size;
        this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
        this.currentPage = 1;
        this.paginated();
      },
      // Fin paginación
    },
    watch: {
      // Creación
      "form.namePromotion": function(n) {
        if (n) {
          this.errors.namePromotion = false;
        } else {
          this.errors.namePromotion = "Este campo es requerido.";
        }
      },
      "form.initialDate": function(n) {
        if (n) {
          this.errors.initialDate = false;
        } else {
          this.errors.initialDate = "Este campo es requerido.";
        }
      },
      "form.finalDate": function(n) {
        if (n) {
          this.errors.finalDate = false;
        } else {
          this.errors.finalDate = "Este campo es requerido.";
        }
      },
      "form.segment": function(n) {
        if (n) {
          this.errors.segment = false;
        } else {
          this.errors.segment = "Este campo es requerido.";
        }
      },
      "form.distributor": function(n) {
        if(this.form.segment == 1){
          if (n) {
            this.errors.distributor = false;
          } else {
            this.errors.distributor = "Este campo es requerido.";
          }
        }
      },
      "form.typeUser": function(n) {
        if(this.form.segment == 2){
          if (n) {
            this.errors.typeUser = false;
          } else {
            this.errors.typeUser = "Este campo es requerido.";
          }
        }
      },
      "form.points": function(n) {
        if (n) {
          this.errors.points = false;
        } else {
          this.errors.points = "Este campo es requerido.";
        }
      },

      // Edición
      "formEdit.namePromotion": function(n) {
        if (n) {
          this.errors.namePromotion = false;
        } else {
          this.errors.namePromotion = "Este campo es requerido.";
        }
      },
      "formEdit.initialDate": function(n) {
        if (n) {
          this.errors.initialDate = false;
        } else {
          this.errors.initialDate = "Este campo es requerido.";
        }
      },
      "formEdit.finalDate": function(n) {
        if (n) {
          this.errors.finalDate = false;
        } else {
          this.errors.finalDate = "Este campo es requerido.";
        }
      },
      "formEdit.segment": function(n) {
        if (n) {
          this.errors.segment = false;
        } else {
          this.errors.segment = "Este campo es requerido.";
        }
      },
      "formEdit.distributor": function(n) {
        if(this.formEdit.segment == 1){
          if (n) {
            this.errors.distributor = false;
          } else {
            this.errors.distributor = "Este campo es requerido.";
          }
        }
      },
      "formEdit.typeUser": function(n) {
        if(this.formEdit.segment == 2){
          if (n) {
            this.errors.typeUser = false;
          } else {
            this.errors.typeUser = "Este campo es requerido.";
          }
        }
      },
      "formEdit.points": function(n) {
        if (n) {
          this.errors.points = false;
        } else {
          this.errors.points = "Este campo es requerido.";
        }
      },
    },
    mounted() {
      this.getDistributors();
      this.getPromotions();
    },
  };
</script>

<style>
  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }
  .page-link {
    border-radius: 100px;
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #dc3545;
    background-color: #fff;
    border: 1px solid #dee2e6;
  }
  .page-link:hover {
    color: #000;
  }
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
</style>
  